// extracted by mini-css-extract-plugin
export default {"addToCartControl":"HZ-z","giftCard":"IZ-z","btnContainer":"JZ-z","cartButton":"KZ-z","disabled":"LZ-z"};